module.exports = __webpack_public_path__ + "img/dice-6.c7f17947.svg";